import { createCrewLookupSelect } from './createCrewLookupSelect';

export const ReligionSelect = createCrewLookupSelect('ReligionSelect', 'religions');
export default ReligionSelect;
